import * as React from 'react';
import Affix from '@telia-front/affix';
import Button from '@telia-front/button';
import Heading from '@telia-front/heading';
import Separator from '@telia-front/separator';
import { Table } from '@telia-front/table';
import DesktopChannelRow from './desktop-channel-row';
import DesktopPacketRow from './desktop-packet-row';
import DesktopServiceRow from './desktop-service-row';
import DesktopTableHeader from './desktop-table-header';
import DesktopViewerSlotRow from './desktop-viewer-slot-row';
const DesktopTable = (props) => {
    const { packets, sections, initialHeadingLevel = 2, filter } = props;
    const renderSection = (section) => {
        var _a, _b, _c, _d, _e, _f;
        switch (section.type) {
            case 'serviceGroups': {
                const { type, data: serviceGroups } = section;
                return serviceGroups && serviceGroups.services.length > 0 ? (React.createElement(React.Fragment, { key: type },
                    React.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
                    React.createElement(Heading, { level: initialHeadingLevel, className: "h4 tv-comparison__header" },
                        serviceGroups.title,
                        serviceGroups.count && (React.createElement(React.Fragment, null,
                            " ",
                            React.createElement("span", { className: "text-light" },
                                "(",
                                serviceGroups.count,
                                ")")))),
                    React.createElement(Table, { className: "tv-comparison__table", bordered: true },
                        React.createElement("thead", { className: "sr-only" },
                            React.createElement(DesktopTableHeader, { packets: packets })),
                        React.createElement("tbody", null, serviceGroups.services.map((service, index) => (React.createElement(DesktopServiceRow, { service: service, numberOfPackets: packets.length, key: index }))))),
                    serviceGroups.viewAllButton && (React.createElement(React.Fragment, null,
                        React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
                        React.createElement("p", { className: "text-center" },
                            React.createElement(Button, Object.assign({}, serviceGroups.viewAllButton))))))) : undefined;
            }
            case 'themePackets': {
                const { type, data: themePackets } = section;
                return themePackets && themePackets.packets.length > 0 ? (React.createElement(React.Fragment, { key: type },
                    React.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
                    React.createElement(Heading, { level: initialHeadingLevel, className: "h4 tv-comparison__header" },
                        themePackets.label,
                        themePackets.count && (React.createElement(React.Fragment, null,
                            " ",
                            React.createElement("span", { className: "text-light" },
                                "(",
                                themePackets.count,
                                ")")))),
                    React.createElement(Table, { className: "tv-comparison__table", bordered: true },
                        React.createElement("thead", { className: "sr-only" },
                            React.createElement(DesktopTableHeader, { packets: packets })),
                        React.createElement("tbody", null, themePackets.packets.map((packet, index) => (React.createElement(DesktopPacketRow, { packet: packet, numberOfPackets: packets.length, key: index }))))),
                    themePackets.viewAllButton && (React.createElement(React.Fragment, null,
                        React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
                        React.createElement("p", { className: "text-center" },
                            React.createElement(Button, Object.assign({}, themePackets.viewAllButton))))))) : undefined;
            }
            case 'channels': {
                const { type, data: channels } = section;
                const allChannelsShown = channels.channels.length + (((_b = (_a = channels.separatedChannels) === null || _a === void 0 ? void 0 : _a.channels) === null || _b === void 0 ? void 0 : _b.length) || 0) === channels.count;
                return channels.channels.length || !!((_d = (_c = channels.separatedChannels) === null || _c === void 0 ? void 0 : _c.channels) === null || _d === void 0 ? void 0 : _d.length) ? (React.createElement(React.Fragment, { key: type },
                    React.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
                    React.createElement(Heading, { level: initialHeadingLevel, className: "h4 tv-comparison__header" },
                        channels.label,
                        channels.count && (React.createElement(React.Fragment, null,
                            " ",
                            React.createElement("span", { className: "text-light" },
                                "(",
                                channels.count,
                                ")")))),
                    !!channels.channels.length && (React.createElement(Table, { className: "tv-comparison__table", bordered: true },
                        React.createElement("thead", { className: "sr-only" },
                            React.createElement(DesktopTableHeader, { packets: packets })),
                        React.createElement("tbody", null, channels.channels.map((channel, index) => (React.createElement(DesktopChannelRow, { channel: channel, numberOfPackets: packets.length, key: index })))))),
                    !!((_f = (_e = channels.separatedChannels) === null || _e === void 0 ? void 0 : _e.channels) === null || _f === void 0 ? void 0 : _f.length) && allChannelsShown && (React.createElement(React.Fragment, null,
                        !!channels.channels.length && React.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
                        channels.separatedChannels.text,
                        React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
                        React.createElement(Table, { className: "tv-comparison__table", bordered: true },
                            React.createElement("thead", { className: "sr-only" },
                                React.createElement(DesktopTableHeader, { packets: packets })),
                            React.createElement("tbody", null, channels.separatedChannels.channels.map((channel, index) => (React.createElement(DesktopChannelRow, { channel: channel, numberOfPackets: packets.length, key: index }))))))),
                    channels.viewAllButton && (React.createElement(React.Fragment, null,
                        React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
                        React.createElement("p", { className: "text-center" },
                            React.createElement(Button, Object.assign({}, channels.viewAllButton))))))) : undefined;
            }
            case 'viewerSlots': {
                const { type, data: viewerSlots } = section;
                return viewerSlots && viewerSlots.slots.length > 0 ? (React.createElement(React.Fragment, { key: type },
                    React.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
                    React.createElement(Heading, { level: initialHeadingLevel, className: "h4 tv-comparison__header" },
                        viewerSlots.title,
                        " "),
                    React.createElement(Table, { className: "tv-comparison__table", bordered: true },
                        React.createElement("thead", { className: "sr-only" },
                            React.createElement(DesktopTableHeader, { packets: packets })),
                        React.createElement("tbody", null, viewerSlots.slots.map((slot, index) => (React.createElement(DesktopViewerSlotRow, { slot: slot, numberOfPackets: packets.length, key: index }))))))) : undefined;
            }
        }
    };
    const getPacketsProps = () => {
        return packets.map(packet => {
            if (packet.orderButton) {
                packet.orderButton = Object.assign(Object.assign({}, packet.orderButton), { attributes: { tabIndex: -1 } });
            }
            return packet;
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Affix, { "aria-hidden": true },
            React.createElement(Table, { bordered: true, className: "tv-comparison__table" },
                React.createElement("thead", null,
                    React.createElement(DesktopTableHeader, { packets: getPacketsProps() })))),
        filter && React.createElement("div", { className: "tv-comparison__filter" }, filter),
        React.createElement("div", { className: "tv-comparison__body" }, sections.map(renderSection))));
};
export default DesktopTable;
